import { createContext } from "react"

// Types
import { IAppState } from "../types/appState"

const Context = createContext<IAppState | null>(null)

export default Context
